import Navbar from "./components/Navbar/Navbar";
import JobApply from "./components/JobApply/JobApply";
import Contact from "./components/Contact/Contact";
import Hero from "./components/Hero/Hero";
import Skills from "./components/Skills/Skills";
import Footer from "./components/Footer/Footer";
import Projects from "./components/Projects/Projects";

export default function App() {
  return (
    <>
      <Navbar />

      <main className="min-h-screen bg-zinc-950 text-white px-6 py-10 font-sans">

        <div className="max-w-5xl mx-auto space-y-32">

          <Hero />
          <JobApply />
          <Skills />

          <Projects />
          <Contact />
          <Footer />

        </div>

      </main>
    </>
  );
}